export const GLITCHTIP_HEALTH_CHECK_URL = 'glitchtip/health-check-url';
export const GLITCHTIP_ERRORS_CHECK_URL = "glitchtip/errors-check-url";
export const GLITCHTIP_PERFORMANCE_URL = 'glitchtip/performance-check-url';
export const SEV2_PROJECT_BOARD_URL = 'sev2/project-board-url';
export const DEFAULT_TARGET_SLA = 99.0;
export const DEFAULT_TARGET_SLO = 99.1;
export const DEFAULT_TARGET_MTTR = 1;
export const METRIC_TARGET_SLA = 'metric-target/sla';
export const METRIC_TARGET_SLO = 'metric-target/slo';
export const METRIC_TARGET_MTTR = 'metric-target/mttr';
export const SEV2_BACKSTAGE_ERROR_TRACKING_PROJECT_ID = 3207;
